<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Norm-Cen" id="auto_bookmark_toc_3"><span>To my mum, who always encouraged me to have my head in the clouds. And to the Five, who told me to stop messing around and get my fingers on a keyboard.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0003.vue?53eb3e21